import React, { useEffect, useState } from "react";
import AdminHeader from "../../../Components/AdminComponent/AdminHeader/AdminHeader";
import AdminSidebar from "../../../Components/AdminComponent/AdminSidebar/AdminSidebar";
import PromoCodeComponent from "../../../Components/AdminComponent/PromoCodeComponent/PromoCodeComponent";
import { Apiurl, GetLocalStorageParsed, parseData } from "../../utils/page";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";

const PromoCode = () => {
  const [activeRadio, setActiveRadio] = useState();
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [promoGroupData, setPromoGroupData] = useState();
  const [groupData, setGroupData] = useState();
  const [allUsers, setAllUsers] = useState();
  const [groupEmailData, setGroupEmailData] = useState([]);
  const [showEditGroupModal, setShowEditGroupModal] = useState(false);
  const [addNewGroupModal, setAddNewGroupModal] = useState(false);
  const [newAddedEmail, setNewAddedEmail] = useState([]);
  const [selectedEmailData, setSelectedEmail] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const [newGroupName, setNewGroupName] = useState();
  const [promoCodeData, setPromoCodeData] = useState();
  const [viewEmailDataModal, setViewEmailDataModal] = useState(false);
  const [editEmailData, setEditEmailData] = useState([]);
  const [editPromoData, setEditPromoData] = useState();
  const [formData, setFormData] = useState({
    Type: "",
    PromoCode: "",
    MinAmount: "",
    FromDate: "",
    ToDate: "",
    Description: "",
    Mode: "",
    NumberOfUsers: "",
    Active: "",
  });
  const [errorMessage, setErrorMessage] = useState({
    Type: "",
    PromoCode: "",
    MinAmount: "",
    FromDate: "",
    ToDate: "",
    Description: "",
    Mode: "",
    NumberOfUsers: "",
    Active: "",
  });
  const currentDate = moment().format("YYYY-MM-DD");

  const getPromoCodeData = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/PromoCode/GetPromoCode`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setPromoCodeData(data);
      })
      .catch((error) => {});
  };

  const getPromoGroups = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/PromoCode/GetPromoGroups`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setPromoGroupData(data);
      })
      .catch((error) => {});
  };
  const getAllUsers = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/SuperAdmin/GetAllUsers`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        const filterData = data?.filter((i) => i?.Email !== null);
        setAllUsers(filterData);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    getPromoGroups();
    getAllUsers();
    getPromoCodeData();
  }, []);
  const handleGetGroupData = (e) => {
    const data = {
      Id: e?.Id || selectedGroup?.Id,
      GroupName: e?.GroupName || selectedGroup?.GroupName,
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/GetGroupData`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setGroupEmailData(data?.Emails?.split(","));
        setGroupData(data);
      })
      .catch((error) => {});
  };

  const handleCloseEditGroupModal = () => {
    setShowEditGroupModal(false);
  };
  const handleCloseAddGroupModal = () => {
    setAddNewGroupModal(false);
  };
  const handleCloseViewEmailDataModal = () => {
    setViewEmailDataModal(false);
  };

  const handleSavePromoGroup = () => {
    const data = {
      Id: selectedGroup?.Id,
      GroupName: selectedGroup?.GroupName,
      Emails: groupEmailData.join(", "),
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/SavePromoGroup`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        handleGetGroupData();
        setShowEditGroupModal(false);
      })
      .catch((error) => {});
  };
  const handleAddNewGroup = () => {
    const data = {
      GroupName: newGroupName,
      Emails: newAddedEmail.join(", "),
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/SavePromoGroup`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        handleGetGroupData();
        getPromoGroups();
        setAddNewGroupModal(false);
      })
      .catch((error) => {});
  };
  const validations = () => {
    const errors = {};
    if (!formData?.Type) {
      errors.Type = "Please select type";
    }
    if (!formData?.PromoCode || formData?.PromoCode?.trim() === "") {
      errors.PromoCode = "Please enter Promo Code";
    }
    if (!formData?.MinAmount || formData?.MinAmount?.trim() === "") {
      errors.MinAmount = "Please enter Amount";
    }

    if (!formData?.FromDate) {
      errors.FromDate = "From Date Is Required";
    }
    if (!formData?.ToDate) {
      errors.ToDate = "To Date Is Required";
    }

    if (!formData?.Description || formData?.Description?.trim() === "") {
      errors.Description = "Description is Required";
    }
    if (!formData?.Mode || formData?.Mode?.trim() === "") {
      errors.Mode = "Please select Mode";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessage({
      Type: "",
      PromoCode: "",
      MinAmount: "",
      FromDate: "",
      ToDate: "",
      Description: "",
      Mode: "",
      NumberOfUsers: "",
      Active: "",
    });
    return true;
  };
  const handleAddPromo = () => {
    if (!validations()) return;
    const data = {
      PromoCode: formData.PromoCode,
      MinAmount: formData.MinAmount,
      FromDate: formData.FromDate,
      ToDate: formData.ToDate,
      NumberOfUsers:
        formData.NumberOfUsers || JSON.stringify(groupEmailData?.length),
      Active: true,
      Emails: groupEmailData.join(", "),
      Type: formData.Type,
      Mode: formData.Mode,
      Description: formData.Description,
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/SavePromoCode`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        getPromoCodeData();
        setFormData({
          ...formData,
          Type: "",
          PromoCode: "",
          MinAmount: "",
          FromDate: "",
          ToDate: "",
          Description: "",
          Mode: "",
          NumberOfUsers: "",
          Active: "",
        });
        setGroupEmailData([]);
        setSelectedGroup();
        setActiveRadio();
      })
      .catch((error) => {});
  };
  const updateUserGroup = () => {
    const data = {
      Id: editPromoData?.Id,
      PromoCode: editPromoData.PromoCode,
      MinAmount: editPromoData.MinAmount,
      FromDate: editPromoData.FromDate,
      ToDate: editPromoData.ToDate,
      NumberOfUsers: JSON.stringify(editEmailData?.length),
      Active: true,
      Emails: editEmailData.join(", "),
      Type: editPromoData.Type,
      Mode: editPromoData.Mode,
      Description: editPromoData.Description,
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/SavePromoCode`,
    };
    axios(option)
      .then((e) => {
          if (e?.data?.status === "OK") {
                  toast.success(e?.data?.message);
                }
                if (e?.data?.status === "BadRequest") {
                    toast.error(e?.data?.message);
                  }
        getPromoCodeData();
        setViewEmailDataModal(false);
      })
      .catch((error) => {});
  };
  const handleDeletePromo = (e) => {
    const data = {
      PromoCodeId: e?.Id,
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/PromoCode/DeletePromoCode`,
    };
    axios(option)
      .then((e) => {
          if (e?.data?.status === "OK") {
                  toast.success(e?.data?.message);
                }
                if (e?.data?.status === "BadRequest") {
                    toast.error(e?.data?.message);
                  }
        getPromoCodeData();
      })
      .catch((error) => {});
  };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      <AdminHeader />
      <div className="row col-lg-12">
        <AdminSidebar />
        <div className="col-lg-10 right_content">
          <PromoCodeComponent
            activeRadio={activeRadio}
            setActiveRadio={setActiveRadio}
            promoGroupData={promoGroupData}
            handleGetGroupData={handleGetGroupData}
            allUsers={allUsers}
            groupEmailData={groupEmailData}
            setSelectedEmail={setSelectedEmail}
            setGroupEmailData={setGroupEmailData}
            showEditGroupModal={showEditGroupModal}
            setShowEditGroupModal={setShowEditGroupModal}
            handleCloseEditGroupModal={handleCloseEditGroupModal}
            handleSavePromoGroup={handleSavePromoGroup}
            setSelectedGroup={setSelectedGroup}
            addNewGroupModal={addNewGroupModal}
            setAddNewGroupModal={setAddNewGroupModal}
            handleCloseAddGroupModal={handleCloseAddGroupModal}
            newAddedEmail={newAddedEmail}
            setNewAddedEmail={setNewAddedEmail}
            selectedGroup={selectedGroup}
            handleAddNewGroup={handleAddNewGroup}
            newGroupName={newGroupName}
            setNewGroupName={setNewGroupName}
            promoCodeData={promoCodeData}
            setViewEmailDataModal={setViewEmailDataModal}
            viewEmailDataModal={viewEmailDataModal}
            handleCloseViewEmailDataModal={handleCloseViewEmailDataModal}
            editEmailData={editEmailData}
            setEditEmailData={setEditEmailData}
            setFormData={setFormData}
            formData={formData}
            currentDate={currentDate}
            handleAddPromo={handleAddPromo}
            handleDeletePromo={handleDeletePromo}
            updateUserGroup={updateUserGroup}
            setEditPromoData={setEditPromoData}
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
          />
        </div>
      </div>
    </div>
  );
};

export default PromoCode;
